<template>
  <!--
      作者：kmdshop
      时间：2020-06-01
      描述：插件中心-用工类型-修改
    -->
  <el-dialog
    title="修改用工类型"
    :visible.sync="dialogVisible"
    @close="dialogFormVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="50%"
  >

    <div class="product-add pb50">
      <el-form size="small" :model="form" ref="form" :rules="rules" label-width="120px">
        <div class="common-form">修改用工类型</div>
        
        <!-- 新增：所属分类选择（二级分类核心功能） -->
        <el-form-item label="所属分类" prop="parent_id">
          <el-select v-model="form.parent_id" clearable placeholder="请选择所属分类">
            <el-option label="顶级分类" :value="0"></el-option>
            <el-option 
              v-for="item in parentList" 
              :key="item.employment_type_id"
              :value="item.employment_type_id" 
              :label="item.parent_id === 0 ? `${item.name}` : `${item.name}`">
            </el-option>
          </el-select>
          <!-- <div style="color: #999; font-size: 12px; margin-top: 5px;">
            提示：选择"顶级分类"为一级分类，选择其他分类则为二级分类
          </div> -->
        </el-form-item>

        <el-form-item label="用工类型名称" prop="name">
          <el-input v-model="form.name" placeholder="请输入用工类型名称" class="max-w460"></el-input>
        </el-form-item>
      
        <el-form-item label="用工类型图片：" prop="image">
          <div class="draggable-list">
            <draggable class="wrapper" v-model="form.image">
              <transition-group>
                <div v-for="(item, index) in form.image" :key="item.file_path">
                  <div class="item">
                    <img v-img-url="item.file_path" alt="file_path"/>
                    <a href="javascript:void(0);" class="delete-btn" @click.stop="deleteImg(index, 'album')">
                      <i class="el-icon-close"></i>
                    </a>
                  </div>
                </div>
              </transition-group>
            </draggable>
            <div class="item img-select" @click="openProductUpload('album')">
              <i class="el-icon-plus"></i>
            </div>
          </div>
        </el-form-item>

        <el-form-item label="排序" prop="sort">
          <el-input v-model.number="form.sort" placeholder="请输入排序" class="max-w460"></el-input>
        </el-form-item>
        
        <!--提交-->
        <div class="common-button-wrapper">
          <el-button size="small" type="info" @click="cancelFunc">取消</el-button>
          <el-button size="small" type="primary" @click="onSubmit" :loading="loading">提交</el-button>
        </div>
      </el-form>
      
      <Upload v-if="isProductUpload" :config="{ total: 9 }" :isupload="isProductUpload" @returnImgs="returnProductImgsFunc">
        上传图片
      </Upload>
    </div>
  </el-dialog>
</template>

<script>
import Employment_typeApi from '@/api/employment_type.js';
import Upload from '@/components/file/Upload';
import draggable from "vuedraggable";

export default {
  components: {
    Upload,
    draggable
  },
  data() {
    return {
      /*form表单数据*/
      form: {
        name: '',
        parent_id: 0, // 添加父级ID字段
        image: [],
        sort: 50,
      },
      parentList: [], // 可选的父级分类列表
      loading: false,
      /*验证规则*/
      rules: {
        name: [{ required: true, message: '请输入用工类型名称', trigger: 'blur' }],
        sort: [{ type: 'number', message: '排序必须为数字' }]
      },
      dialogVisible: false,
      isProductUpload: false,
      code: "album"
    };
  },
  props: ["open_add", "employment_type_id"],
  created() {
    this.dialogVisible = this.open_add;
    this.getDetail();
    this.getParentList(); // 获取父级列表
  },
  methods: {
    /*获取可选的父级分类列表（排除自身和子分类）*/
    getParentList() {
      Employment_typeApi.getParents({ employment_type_id: this.employment_type_id }, true).then(data => {
        this.parentList = data.data.list;
      });
    },
    
    /*获取详情*/
    getDetail() {
      let self = this;
      Employment_typeApi.detail({ employment_type_id: self.employment_type_id }, true)
        .then(res => {
          self.form = res.data;
          // 确保 parent_id 字段存在
          if (!self.form.parent_id) {
            self.form.parent_id = 0;
          }
          self.loading = false;
        })
        .catch(error => {
          self.loading = false;
        });
    },
    
    /*提交修改*/
    onSubmit() {
      let self = this;
      let form = self.form;
      
      if(form.image.length <= 0){
        self.$message({ message: "请上传图片", type: 'error' });
        return;
      }
      
      self.$refs.form.validate(valid => {
        if (valid) {
          self.loading = true;
          form.employment_type_id = self.employment_type_id;
          Employment_typeApi.edit(form, true)
            .then(data => {
              self.loading = false;
              self.$message({ message: '修改成功', type: 'success' });
              self.dialogFormVisible();
            })
            .catch(error => {
              self.loading = false;
            });
        }
      });
    },
    
    /*关闭弹窗*/
    dialogFormVisible() {
      this.$emit("close", {});
    },
    
    cancelFunc() {
      this.dialogFormVisible();
    },
    
    /*上传图片*/
    openProductUpload: function (code) {
      this.isProductUpload = true;
      this.code = code;
    },
    
    /*上传商品图片*/
    returnProductImgsFunc(e) {
      if(this.code == 'album'){
        if (e != null) {
          let imgExpt = ["bmp", "jpg", "jpeg", "png", "gif"];
          let prevent = false;
          e.forEach((element) => {
            let data_array = element.file_path.split(".");
            let ext = data_array[data_array.length - 1];
            imgExpt.forEach((extType) => {
              if (extType === ext) {
                prevent = true;
                return false;
              }
            });
          });

          if (!prevent) {
            this.$message.error("图片类型有误,请选择正确的图片格式");
            return false;
          }

          let imgs = this.form.image.concat(e);
          this.$set(this.form, "image", imgs);
        }
      }
      this.isProductUpload = false;
    },
    
    /*删除商品图片*/
    deleteImg(index, code) {
      if(code == 'album'){
        this.form.image.splice(index, 1);
      }
    },
  }
};
</script>

<style scoped>
.edit_container {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.ql-editor {
  height: 400px;
}

.draggable-list {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
}

.draggable-list .wrapper > span {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.draggable-list .item {
  position: relative;
  width: 110px;
  height: 110px;
  margin-top: 10px;
  margin-right: 10px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #dddddd;
}

.draggable-list .delete-btn {
  position: absolute;
  top: 0;
  right: 0;
  width: 16px;
  height: 16px;
  background: red;
  line-height: 16px;
  font-size: 16px;
  color: #ffffff;
  display: none;
}

.draggable-list .item:hover .delete-btn {
  display: block;
}

.draggable-list .item img {
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  max-height: 100%;
  max-width: 100%;
}

.draggable-list .img-select {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px dashed #dddddd;
  font-size: 30px;
}

.draggable-list .img-select i {
  color: #409eff;
}
</style>


// WEBPACK FOOTER //
// src/views/plus/employment_type/index/part/edit.vue